/* eslint-disable import/order */
import React from 'react';
import { AuthenticationCheck } from '@jira/spa-apps__common/src/AuthenticationCheck.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { piCreateIssueEmbedRoute } from '@jira/router-routes__product-integrations-routes/src/piCreateIssueEmbedRoute.tsx';
import type { CreateIssueEmbed } from '@jira/growth__gmail-embed/src/ui/create-issue/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyPICreateIssueEmbed = lazyForPaint<typeof CreateIssueEmbed>(
	() =>
		import(
			/* webpackChunkName: "async-pi-issue-create-embed", jiraSpaEntry: "async-pi-issue-create-embed" */ '@jira/growth__gmail-embed/src/ui/create-issue/index.tsx'
		).then((module) => module.CreateIssueEmbed),
	{ ssr: false },
);

const PIIssueCreateEmbedLazy = () => {
	return (
		<AuthenticationCheck>
			<LazyPage
				Page={LazyPICreateIssueEmbed}
				pageId="spa-apps/pi-issue-create-embed"
				shouldShowSpinner
			/>
		</AuthenticationCheck>
	);
};

export const piCreateIssueEmbedRouteEntry: Route = createEntry(piCreateIssueEmbedRoute, () => ({
	group: 'issue',
	// eslint-disable-next-line no-restricted-syntax
	component: PIIssueCreateEmbedLazy,
	resources: [...jiraSpaResources()],
	layout: chromelessLayout,
	forPaint: [LazyPICreateIssueEmbed],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
